import { render, staticRenderFns } from "./tf50.vue?vue&type=template&id=d663323a&"
import script from "./tf50.vue?vue&type=script&lang=js&"
export * from "./tf50.vue?vue&type=script&lang=js&"
import style0 from "./tf50.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports